class LettersTab {
  constructor($scope, GpAddress) {
    Object.assign(this, {
      $scope,
      GpAddress,
      letters: []
    });
  }

  $onInit() {
    if (this.visit.gp_letter_required && this.visit.gp_letter_printed) {
      this.GpAddress.printLetters([this.visit.id.toString()])
        .then((data) => {
          const size = {
            value: data.data.size,
            unit: 'b',
          };
          let i = 0;
          const units = ['kb', 'mb', 'gb'];
          while (Math.floor(size.value / 1000) > 0) {
            size.value /= 1000;
            size.unit = units[i];
            i += 1;
          }
          console.log(data);
          this.letters.push({
            title: data.headers('content-disposition').match(/filename=(.*)/)[1].replaceAll('"', ''),
            file_type: data.data.type,
            letter_type: 'gp_letter',
            blob: data.data,
            size,
          });
        })
        .catch((err) => {
        });
    }
  }

  downloadFile(blob) {
    const file = new Blob([blob.blob], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  }
}

LettersTab.$inject = ['$scope', 'GpAddress'];
angular.module('pims').component('lettersTab', {
  templateUrl: 'app/views/visits/detail/sections/documents/letters/letters.component.html',
  controller: LettersTab,
  controllerAs: 'vm',
  bindings: {
    visit: '=',
  },
});
